import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { BasicModalModel } from '../../models/basic-modal/BasicModalModel';

@Component({
    selector: 'app-basic-confirm-modal',
    templateUrl: './basic-confirm-modal.component.html',
    styleUrls: ['./basic-confirm-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BasicConfirmModalComponent implements OnInit {

  constructor(
      @Inject(MAT_DIALOG_DATA) public readonly modalContent: BasicModalModel,
      private readonly dialogRef: MatDialogRef<BasicConfirmModalComponent>
  ) {
  }

  ngOnInit(): void {
  }

  onActionTaken(event: boolean){
    this.dialogRef.close(event);
  }

}
